// Animate timeline events when they scroll into view
(function () {
  function onIntersect(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("timeline__event--visible");
        observer.unobserve(entry.target);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".timeline__event");
    if (!items.length) return;
    const observer = new IntersectionObserver(onIntersect, { threshold: 0.2 });
    items.forEach((item) => observer.observe(item));
  });
})();
